var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlClose24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.83,12 L22.61,4.21999998 C23.1155309,3.71446917 23.3129631,2.97764195 23.127926,2.287074 C22.9428889,1.59650605 22.4034939,1.05711109 21.712926,0.87207397 C21.0223581,0.68703686 20.2855308,0.88446913 19.78,1.38999997 L12,9.17 L4.21999998,1.38999997 C3.43851705,0.60851708 2.17148292,0.6085171 1.39000001,1.39000001 C0.6085171,2.17148292 0.60851708,3.43851705 1.38999997,4.21999998 L9.17,12 L1.38999997,19.78 C0.82026774,20.3531318 0.6514359,21.2128157 0.96209995,21.958847 C1.27276401,22.7048782 2.00186977,23.1906409 2.80999997,23.1900013 C3.33814501,23.1904215 3.84501705,22.9819209 4.21999998,22.61 L12,14.83 L19.78,22.61 C20.154983,22.9819209 20.661855,23.1904215 21.19,23.1900013 C21.9981302,23.1906409 22.727236,22.7048782 23.0379,21.958847 C23.3485641,21.2128157 23.1797323,20.3531318 22.61,19.78 L14.83,12 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconActionClose24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconActionClear32"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color",
    mask: "url(#mask-2)",
    fill: "#282828",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -4.000000)",
    id: "Rectangle-Copy-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlClose24);
export default __webpack_public_path__ + "static/media/controlClose24.b34f38f82978257b40b9399f23da7633.svg";
export { ForwardRef as ReactComponent };